/** SkipLink: the first Tab stop on a page. Hidden until focused; it moves focus past the navigation to the element with `targetId` (give that element `tabIndex={-1}`). */
import type { MouseEvent, ReactNode } from "react";
import { cx, focusRing } from "./cx";

export function SkipLink({ targetId, children }: { targetId: string; children: ReactNode }) {
  const skip = (event: MouseEvent) => {
    event.preventDefault();
    document.getElementById(targetId)?.focus();
  };
  return (
    <a
      href={`#${targetId}`}
      onClick={skip}
      // Transparent, not clipped, until focused: it keeps a full-size box and takes no pointer. Focused, it also wears the kit's ring, so its focus shows as every control's does.
      className={cx("pointer-events-none fixed left-3 top-3 z-[70] rounded-lg bg-primary px-3 py-2.5 text-body font-medium leading-none text-primary-foreground opacity-0 shadow-popover focus-visible:pointer-events-auto focus-visible:opacity-100", focusRing)}
    >
      {children}
    </a>
  );
}
